import { render } from "./ElementaryTeacherListGradeLevel.vue?vue&type=template&id=a2c4173e"
import script from "./ElementaryTeacherListGradeLevel.vue?vue&type=script&lang=js"
export * from "./ElementaryTeacherListGradeLevel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__